import React from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import StorageService from '../../services/StorageService';

function AccessDenied() {
  const navigate = useNavigate();

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography component="h1" variant="h4" sx={{ mb: 3 }}>
          Acesso Negado
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, textAlign: 'center' }}>
          Você não tem permissão para acessar esta área. Esta seção é restrita apenas para administradores.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            StorageService.clearAuth();
             navigate('/')
            }
          }
          sx={{ mt: 2 }}
        >
          Ir para Login
        </Button>
      </Box>
    </Container>
  );
}

export default AccessDenied;
